module.exports = __webpack_public_path__ + "static/media/crecer.4330d3f1.svg";